import dynamic from "next/dynamic";
import { useCallback, useEffect, useRef, useState } from "react";
import Image from 'next/image';
import environment from "../../utils/environment";
import { addKeyToImage } from "../../utils/utils";

const ReactPlayer = dynamic(() => import('react-player'));

interface VideoPlayerProps {
    url: string;
    className: string;
    id?: string,
    ref?: any,
    autoPlay?: boolean,
    muted?: boolean,
    onReady?: Function,
    url_thumbnail?: string,
    height?: number
}

const VideoPlayer: React.FC<VideoPlayerProps> = ({
    url,
    className,
    id,
    ref,
    autoPlay=false,
    muted=false,
    onReady= null,
    url_thumbnail = '',
    height = 500
}) => {
    // const [onPlay, setOnPlay] = useState(autoPlay);
    // const [hasWindow, setHasWindow] = useState(false);
    const onReadyHandler = useCallback(() => {
        if(onReady){
            onReady();
        }
    }, []);

    const generateThumbnail = () =>{
        return <>
                <div className="wrap-thumbnail-video">
                    <Image
                        className='relative w-full rounded-[8px]'
                        src={url_thumbnail}
                        alt='Thumbnail'
                        title='Thumbnail'
                        loading={'eager'}
                        priority
                        fill
                        style={{ objectFit: 'cover' }}
                        onLoadingComplete={() => {
                            if(onReady)
                                onReady();
                        }}
                    />
                    <div className="cover-thumbnail"></div>
                </div> 
            </>
    }

    const generateButtonPlay = () =>{
        return <>
                <div className="wrap-button-play text-semibold-quicksand">
                    <Image src={'/asset/icon/loading_video.gif'} alt='Click để xem' priority width={90} height={90}/>
                    Bấm để xem video
                </div>
            </>
    }
    
    return (
        <>
            {/* <div onClick={() => { setOnPlay(!onPlay) }} className='iframe-container-div h-full w-full flex md:hidden'>
                <ReactPlayer
                    // config={{ file: { attributes: { poster: (url_thumbnail ? url_thumbnail : '/asset/image/loading.svg') }}}}
                    light={<img src={thumbnail} alt='Thumbnail' style={{ width: '100%', height: '100%' }}/>}
                    muted={muted}
                    playing={onPlay}
                    controls={true} 
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    className={className + " max-h-[70vh] lg:max-h-full "}
                    url={url}
                    fetchpriority="high"/>
            </div> */}
            {
                !autoPlay ? 
                    <ReactPlayer
                        light={generateThumbnail()}
                        playIcon={generateButtonPlay()}
                        // onReady={onReadyHandler}
                        ref={ref}
                        id={id ? id : "vid_"}
                        muted={muted}
                        controls={true} 
                        playing={true}
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        className={className + " m "}
                        style={{objectFit: "cover"}}
                        height={height}
                        url={url} 
                        fetchpriority="high"/>
                :
                    <ReactPlayer
                        // onReady={onReadyHandler}
                        ref={ref}
                        id={id ? id : "vid_"}
                        muted={muted}
                        controls={true} 
                        playing={true}
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        className={className + " m "}
                        style={{objectFit: "cover"}}
                        height={height}
                        url={url} 
                        fetchpriority="high"/>
            }
            

        </>
        // : <div className="wrap_loading_video">
        //         <Image
        //             priority={true}
        //             className='relative z-[32]'
        //             src={"/asset/image/loading.svg"}
        //             alt="product_tab_item"
        //             width={64}
        //             height={64}
        //             sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
        //         />
        //         <span>Đang tải Video vui lòng đợi!</span>
        //     </div>
        );
}

export default VideoPlayer;